import { memo, FC } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import resets from '../../_resets.module.css';
import classes from './Contact.module.scss';
import { Button_contact } from "../Button/Button_contact/Button_contact";

interface Props {
  className?: string;
}

export const Contact: FC<Props> = memo(function Contact(props) {
  const { t } = useTranslation();
  return (
    <section className={`${props.className || ''} ${classes.contact}`}>
        <div className={classes.contactTitle}>CONTACT</div>
        <div className={classes.contactDescription}>
        <Trans i18nKey="common:contact.contactDescription" components={{ 1: <span className="nowrap" /> }} />
        </div>
        <Button_contact className={classes.contactButton} />
 </section>
  );
});


